import { ExitGameModalTranslations } from "./types";

export const enTranslations: ExitGameModalTranslations = {
    title: "Attention!",
    subtitle: "Are you sure you want to exit this game? You won't be able to rejoin.",
    leaveText:"Leave",
    cancelText:"Cancel"
};